import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TCreateOrUpdateSupportedPostalOperatorRequest,
	TSupportedPostalOperator,
	TSupportedPostalOperatorIdRequest,
	TSupportedPostalOperatorListResponse,
	TSupportedPostalOperatorsManagementRequest,
	TSupportedPostalOperatorsStore,
	TUpdateSupportedPostalOperatorRequest,
} from './types';

// ==========================================:
export const initialState: TSupportedPostalOperatorsStore = {
	list: null,
	listLoading: false,
	lastListParams: null,
	details: null,
	detailsLoading: false,
	saveLoading: false,
	saveSuccess: false,
	deleteLoading: false,
};

// ==========================================:
const supportedPostalOperatorsSlice = createSlice({
	name: '@@supportedPostalOperators',
	initialState,
	reducers: {
		getSupportedPostalOperatorListRequest: (
			state,
			action: PayloadAction<TSupportedPostalOperatorsManagementRequest>,
		) => {
			state.listLoading = true;
			state.lastListParams = action.payload;
		},
		getSupportedPostalOperatorListSuccess: (
			state,
			action: PayloadAction<TSupportedPostalOperatorListResponse>,
		) => {
			state.list = action.payload;
			state.listLoading = false;
		},
		getSupportedPostalOperatorListFailure: (state) => {
			state.listLoading = false;
		},

		getSupportedPostalOperatorDetailsRequest: (
			state,
			_action: PayloadAction<TSupportedPostalOperatorIdRequest>,
		) => {
			state.detailsLoading = true;
		},
		getSupportedPostalOperatorDetailsSuccess: (
			state,
			action: PayloadAction<TSupportedPostalOperator>,
		) => {
			state.details = action.payload;
			state.detailsLoading = false;
		},
		getSupportedPostalOperatorDetailsFailure: (state) => {
			state.detailsLoading = false;
		},
		clearSupportedPostalOperatorDetails: (state) => {
			state.details = null;
		},

		createSupportedPostalOperatorRequest: (
			state,
			_action: PayloadAction<TCreateOrUpdateSupportedPostalOperatorRequest>,
		) => {
			state.saveLoading = true;
			state.saveSuccess = false;
		},
		updateSupportedPostalOperatorRequest: (
			state,
			_action: PayloadAction<TUpdateSupportedPostalOperatorRequest>,
		) => {
			state.saveLoading = true;
			state.saveSuccess = false;
		},
		saveSupportedPostalOperatorSuccess: (state) => {
			state.saveLoading = false;
			state.saveSuccess = true;
		},
		saveSupportedPostalOperatorFailure: (state) => {
			state.saveLoading = false;
		},
		resetSaveSupportedPostalOperatorSuccess: (state) => {
			state.saveSuccess = false;
		},

		deleteSupportedPostalOperatorRequest: (
			state,
			_action: PayloadAction<TSupportedPostalOperatorIdRequest>,
		) => {
			state.deleteLoading = true;
		},
		deleteSupportedPostalOperatorSuccess: (state) => {
			state.deleteLoading = false;
		},
		deleteSupportedPostalOperatorFailure: (state) => {
			state.deleteLoading = false;
		},

		supportedPostalOperatorsInitState: () => initialState,
	},
});

export default supportedPostalOperatorsSlice.reducer;
export const {
	getSupportedPostalOperatorListRequest,
	getSupportedPostalOperatorListSuccess,
	getSupportedPostalOperatorListFailure,
	getSupportedPostalOperatorDetailsRequest,
	getSupportedPostalOperatorDetailsSuccess,
	getSupportedPostalOperatorDetailsFailure,
	clearSupportedPostalOperatorDetails,
	createSupportedPostalOperatorRequest,
	updateSupportedPostalOperatorRequest,
	saveSupportedPostalOperatorSuccess,
	saveSupportedPostalOperatorFailure,
	resetSaveSupportedPostalOperatorSuccess,
	deleteSupportedPostalOperatorRequest,
	deleteSupportedPostalOperatorSuccess,
	deleteSupportedPostalOperatorFailure,
	supportedPostalOperatorsInitState,
} = supportedPostalOperatorsSlice.actions;
